<template>
  <template v-if="showTopCreateForm">
    <post-saved v-if="showLastSavedPost"> </post-saved>
    <post-create v-else @created-post="createdPostUp" />
  </template>
  <post-respond-banned class="anz-my-xl" />
  <top-login-banner v-if="showTopLoginBanner" />
  <technical-shutdown v-if="showTechnicalShutdownBanner" />

  <div
    class="anz-flex anz-flex-wrap anz-justify-content-between anz-align-items-center anz-mt-xl"
  >
    <strong class="anz-strong anz-text-nowrap anz-pr-m anz-fs-xss" v-if="topic">
      {{ totalCount }}
      {{ $translateCount('post.texts.postCountText', totalCount) }}
    </strong>
    <div class="anz-ml-auto-mo">
      <PostListMenu />
    </div>
  </div>
  <hr class="anz-hr anz-mt-s anz-mb-l" />

  <div
    class="anz-align-center anz-pb-xl anz-mt-xl anz-pt-xs anz-fade anz-fade--bottom"
    v-if="hasBefore"
  >
    <a-button
      class-name="anz-btn anz-btn-primary anz-btn-l anz-wf anz-mb-xs"
      @click="loadBefore"
    >
      <template #title>
        {{ $translate('post.actions.loadBefore') }}
      </template>
    </a-button>
  </div>
  <a-loader v-if="loadingBefore" class-name="anz-mb-l"></a-loader>
  <Suspense>
    <template #default>
      <component :is="activePage"></component>
    </template>
    <template #fallback>
      <a-loader class-name="my-l" />
    </template>
  </Suspense>

  <a-loader v-if="loadingList" class-name="anz-mb-l"></a-loader>
  <div class="anz-align-center anz-mb-l anz-mt-l" v-if="hasNext">
    <a-button
      class-name="anz-btn anz-btn-primary anz-btn-l anz-wf"
      @click="loadNext"
    >
      <template #title>
        <template v-if="hasBefore">
          {{ $translate('post.actions.loadNext') }}
        </template>
        <template v-else>
          {{
            $translateCount('post.actions.loadNextPluralized', remaining, {
              count: remaining ?? 0,
            })
          }}
        </template>
      </template>
    </a-button>
  </div>

  <div class="anz-mt-l anz-mb-xl" v-if="showSubscribeTopicButton">
    <a-button
      @click="subscribeTopic"
      :loading="isTopicSubscribing"
      :disabled="isTopicSubscribing"
      class-name="anz-btn anz-btn-border anz-wf anz-btn-l"
      :title="$translate(subscribeTopicText)"
      icon-width="1.0714em"
      icon-height="1.0714em"
      icon-class="anz-mr-s"
      loader-class="anz-spinner-xs"
    >
    </a-button>
  </div>

  <template v-if="showBottomCreateForm">
    <post-create @created-post="createdPostBottom"> </post-create>
  </template>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ALoader from '@/components/ALoader.vue'
import PostCreate from '@/components/Post/PostCreate.vue'
import { usePostListUiActions } from '@/composables/ui/uiActions'
import PostOldestList from '@/components/Post/PostOldestList.vue'
import PostNewestList from '@/components/Post/PostNewestList.vue'
import PostShowList from '@/components/Post/PostShowList.vue'
import PostBestList from '@/components/Post/PostBestList.vue'
import useTopic from '@/composables/topic/topic'
import PostListMenu from '@/components/Post/PostListMenu.vue'
import usePostsLoader from '@/composables/post/postLoader'
import usePostListMenu from '@/composables/ui/postListMenu'
import PostSaved from '@/components/Post/PostSaved.vue'
import PostRespondBanned from '@/components/Post/PostRespondBanned.vue'
import TopLoginBanner from '@/components/Post/TopLoginBanner.vue'
import TechnicalShutdown from '@/components/TechnicalShutdown.vue'
import useAppState from '@/composables/ui/ui'
import usePostSingleLoader from '@/composables/post/postSingleLoader'
import AButton from '@/components/Forms/AButton.vue'
import usePostList from '@/composables/post/postList'
import usePostCreate from '@/composables/post/postCreate'
import { useSubscribeTopic } from '@/composables/subscribers/subscribersManager'
import useConfiguration from '@/composables/configuration/configuration'
import useCurrentUser from '@/composables/user/user'

export default defineComponent({
  name: 'PostList',
  components: {
    AButton,
    TechnicalShutdown,
    TopLoginBanner,
    PostRespondBanned,
    PostSaved,
    PostListMenu,
    PostCreate,
    ALoader,
    PostOldestList,
    PostNewestList,
    PostBestList,
    PostShowList,
  },
  setup() {
    const { configuration } = useConfiguration()
    return {
      ...usePostCreate(),
      ...useTopic(),
      ...usePostListUiActions(),
      ...usePostsLoader(),
      ...usePostList(),
      ...usePostListMenu(),
      ...useAppState(),
      ...usePostSingleLoader(),
      ...usePostsLoader(),
      ...useSubscribeTopic(configuration.widget.topicId),
      ...useCurrentUser(),
    }
  },
})
</script>
